<div
  class="tf-rich-editor"
  [class.tf-rich-editor--dragging]="dragState()"
  (dragenter)="onWrapperDragEnter($event)"
  (dragover)="onWrapperDragOver($event)"
  (dragleave)="onWrapperDragLeave()"
  (drop)="onWrapperDrop($event)">
  <div class="tf-rich-editor__toolbar" role="toolbar" [attr.aria-label]="'COMMENTS.EDITOR.TOOLBAR' | translate">
    <div class="tf-rich-editor__group">
      <button
        type="button"
        class="tf-rich-editor__btn"
        [disabled]="!active().canUndo"
        [attr.aria-label]="'COMMENTS.EDITOR.UNDO' | translate"
        title="Undo (⌘Z)"
        (mousedown)="$event.preventDefault()"
        (click)="undo()">
        <i class="pi pi-replay" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [disabled]="!active().canRedo"
        [attr.aria-label]="'COMMENTS.EDITOR.REDO' | translate"
        title="Redo (⇧⌘Z)"
        (mousedown)="$event.preventDefault()"
        (click)="redo()">
        <i class="pi pi-refresh" aria-hidden="true"></i>
      </button>
    </div>

    <span class="tf-rich-editor__sep" aria-hidden="true"></span>

    <div class="tf-rich-editor__group">
      <button
        type="button"
        class="tf-rich-editor__btn tf-rich-editor__btn--dropdown"
        [attr.aria-label]="'COMMENTS.EDITOR.HEADING_DROPDOWN' | translate"
        (mousedown)="$event.preventDefault()"
        (click)="headingMenu.toggle($event)">
        <span>{{ headingLabel() }}</span>
        <i class="pi pi-chevron-down" aria-hidden="true"></i>
      </button>
      <p-menu
        #headingMenu
        [model]="headingMenuItems()"
        [popup]="true"
        appendTo="body" />
    </div>

    <span class="tf-rich-editor__sep" aria-hidden="true"></span>

    <div class="tf-rich-editor__group">
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().bold"
        [attr.aria-pressed]="active().bold"
        [attr.aria-label]="'COMMENTS.EDITOR.BOLD' | translate"
        title="Bold (⌘B)"
        (mousedown)="$event.preventDefault()"
        (click)="toggleBold()">
        <strong>B</strong>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().italic"
        [attr.aria-pressed]="active().italic"
        [attr.aria-label]="'COMMENTS.EDITOR.ITALIC' | translate"
        title="Italic (⌘I)"
        (mousedown)="$event.preventDefault()"
        (click)="toggleItalic()">
        <em>I</em>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().strike"
        [attr.aria-pressed]="active().strike"
        [attr.aria-label]="'COMMENTS.EDITOR.STRIKE' | translate"
        title="Strikethrough (⇧⌘X)"
        (mousedown)="$event.preventDefault()"
        (click)="toggleStrike()">
        <span class="tf-rich-editor__btn-text"><s>S</s></span>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().code"
        [attr.aria-pressed]="active().code"
        [attr.aria-label]="'COMMENTS.EDITOR.INLINE_CODE' | translate"
        title="Inline code"
        (mousedown)="$event.preventDefault()"
        (click)="toggleCode()">
        <i class="pi pi-code" aria-hidden="true"></i>
      </button>
    </div>

    <span class="tf-rich-editor__sep" aria-hidden="true"></span>

    <div class="tf-rich-editor__group">
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().link"
        [attr.aria-pressed]="active().link"
        [attr.aria-label]="'COMMENTS.EDITOR.LINK' | translate"
        title="Link"
        (mousedown)="$event.preventDefault()"
        (click)="toggleLink()">
        <i class="pi pi-link" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().blockquote"
        [attr.aria-pressed]="active().blockquote"
        [attr.aria-label]="'COMMENTS.EDITOR.BLOCKQUOTE' | translate"
        title="Quote"
        (mousedown)="$event.preventDefault()"
        (click)="toggleBlockquote()">
        <i class="pi pi-comment" aria-hidden="true"></i>
      </button>
    </div>

    <span class="tf-rich-editor__sep" aria-hidden="true"></span>

    <div class="tf-rich-editor__group">
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().bulletList"
        [attr.aria-pressed]="active().bulletList"
        [attr.aria-label]="'COMMENTS.EDITOR.BULLET_LIST' | translate"
        title="Bullet list"
        (mousedown)="$event.preventDefault()"
        (click)="toggleBulletList()">
        <i class="pi pi-list" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().orderedList"
        [attr.aria-pressed]="active().orderedList"
        [attr.aria-label]="'COMMENTS.EDITOR.ORDERED_LIST' | translate"
        title="Numbered list"
        (mousedown)="$event.preventDefault()"
        (click)="toggleOrderedList()">
        <span class="tf-rich-editor__btn-text">1.</span>
      </button>
      <button
        type="button"
        class="tf-rich-editor__btn"
        [class.tf-rich-editor__btn--active]="active().codeBlock"
        [attr.aria-pressed]="active().codeBlock"
        [attr.aria-label]="'COMMENTS.EDITOR.CODE_BLOCK' | translate"
        title="Code block"
        (mousedown)="$event.preventDefault()"
        (click)="toggleCodeBlock()">
        <span class="tf-rich-editor__btn-text">&lt;/&gt;</span>
      </button>
    </div>

    <span class="tf-rich-editor__sep" aria-hidden="true"></span>

    <div class="tf-rich-editor__group">
      <button
        type="button"
        class="tf-rich-editor__btn"
        [attr.aria-label]="'COMMENTS.EDITOR.ADD_ATTACHMENT' | translate"
        title="Attach file"
        (mousedown)="$event.preventDefault()"
        (click)="onAddImageRequested()">
        <i class="pi pi-paperclip" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <input
    #fileInput
    type="file"
    multiple
    hidden
    [attr.aria-label]="'COMMENTS.EDITOR.ADD_IMAGE' | translate"
    (change)="onImageFilesChosen($event)" />
  <div class="tf-rich-editor__host-wrap">
    <div #editorRoot class="tf-rich-editor__host"></div>
  </div>
  @if (pending().length > 0) {
    <ul
      class="tf-rich-editor__pending-row"
      [attr.aria-label]="'COMMENTS.EDITOR.PENDING_LIST' | translate">
      @for (entry of pending(); track entry.localId) {
        <li
          class="tf-rich-editor__pill"
          [class.tf-rich-editor__pill--uploading]="entry.status === 'uploading'"
          [class.tf-rich-editor__pill--failed]="entry.status === 'failed'">
          <i
            class="tf-rich-editor__pill-icon pi"
            [class.pi-image]="entry.isImage"
            [class.pi-file]="!entry.isImage"
            aria-hidden="true"></i>
          <span class="tf-rich-editor__pill-name" [title]="entry.name">{{ entry.name }}</span>
          <span class="tf-rich-editor__pill-size">{{ entry.sizeBytes | tfFormatBytes }}</span>
          @if (entry.isImage && entry.filestoreFileId && bodyInlineIds().has(entry.filestoreFileId)) {
            <span class="tf-rich-editor__pill-sep" aria-hidden="true"></span>
            <fieldset class="tf-rich-editor__pill-sizes">
              <legend class="sr-only">
                {{ ('COMMENTS.EDITOR.IMAGE_SIZE' | translate) + ' — ' + entry.name }}
              </legend>
              @for (sizeOpt of imageSizeOptions; track sizeOpt.value) {
                <button
                  type="button"
                  class="tf-rich-editor__pill-size-btn"
                  [class.tf-rich-editor__pill-size-btn--active]="entry.size === sizeOpt.value"
                  [attr.aria-pressed]="entry.size === sizeOpt.value"
                  [attr.aria-label]="(sizeOpt.labelKey | translate) + ' — ' + entry.name"
                  (click)="setPendingImageSize(entry.localId, sizeOpt.value)">
                  {{ sizeOpt.short }}
                </button>
              }
            </fieldset>
          }
          @if (entry.status === 'failed' && isRecoverable(entry.error)) {
            <button
              type="button"
              class="tf-rich-editor__pill-retry"
              (click)="retryPending(entry.localId)">
              {{ 'COMMENTS.EDITOR.RETRY' | translate }}
            </button>
          }
          <button
            type="button"
            class="tf-rich-editor__pill-remove"
            [attr.aria-label]="('GENERAL.REMOVE' | translate) + ' ' + entry.name"
            [title]="('GENERAL.REMOVE' | translate) + ' ' + entry.name"
            (click)="removePending(entry.localId)">
            <i class="pi pi-times" aria-hidden="true"></i>
            <span class="sr-only">{{ 'GENERAL.REMOVE' | translate }}</span>
          </button>
          @if (entry.status === 'uploading') {
            <span class="tf-rich-editor__pill-progress" aria-hidden="true"></span>
          }
        </li>
      }
    </ul>
  }
  @if (dragState()) {
    <!-- Drop overlay covers the whole editor surface (toolbar + body + pills) so the user can
         drop anywhere inside the editor. The file's MIME alone decides what happens on drop:
         images land inline at the current cursor position, everything else attaches as a pill.
         Positioned absolutely against `.tf-rich-editor`. -->
    <div class="tf-rich-editor__drop-overlay" aria-hidden="true">
      <i class="pi pi-paperclip" aria-hidden="true"></i>
      <span>{{ 'COMMENTS.EDITOR.DROP_TO_ATTACH' | translate }}</span>
    </div>
  }
</div>
